// import React, { useState } from 'react';
// import { CopyToClipboard } from 'react-copy-to-clipboard';
// import { FaRegCopy, FaEye, FaEyeSlash } from "react-icons/fa";

// const TokenTable = ({ tokens }) => {
//   const [visibleSecrets, setVisibleSecrets] = useState({});
//   const [copiedId, setCopiedId] = useState(null);

//   const toggleSecret = (id) => {
//     setVisibleSecrets((prev) => ({
//       ...prev,
//       [id]: !prev[id],
//     }));
//   };

//   const handleCopy = (id) => {
//     setCopiedId(id);
//     setTimeout(() => setCopiedId(null), 1500); // Reset copied state
//   };

//   const thStyle = { padding: '10px', borderBottom: '1px solid #ccc' };
//   const tdStyle = { padding: '10px', borderBottom: '1px solid #eee' };
//   const iconButtonStyle = {
//     background: 'none',
//     border: 'none',
//     cursor: 'pointer',
//     fontSize: '1em',
//     marginLeft: '8px',
//   };

//   return (
//     <div style={{ overflowX: 'auto', marginTop: 40 }}>
//       <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//         <thead>
//           <tr style={{ backgroundColor: '#f0f0f0' }}>
//             <th style={thStyle}>Token Name</th>
//             <th style={thStyle}>User</th>
//             <th style={thStyle}>Client ID</th>
//             <th style={thStyle}>Secret ID</th>
//             <th style={thStyle}>Expiry Days</th>
//             <th style={thStyle}>Expiry Date</th>
//             <th style={thStyle}>Created</th>
//             <th style={thStyle}>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {tokens.map((token) => (
//             <tr key={token._id}>
//               <td style={tdStyle}>{token.tokenName}</td>
//               <td style={tdStyle}>{token.userName}</td>
//               {/* <td style={tdStyle}>{token.clientId}</td> */}

//               <td style={tdStyle}>
//                 <span>{token.clientId}</span>
//                 <CopyToClipboard
//                   text={token.clientId}
//                   onCopy={() => handleCopy(`client-${token._id}`)}
//                 >
//                   <FaRegCopy color="#fff" style={{ cursor: 'pointer', marginLeft: 10 }} />
//                 </CopyToClipboard>
//                 {copiedId === `client-${token._id}` && (
//                   <span style={{ marginLeft: 5, color: 'green' }}>✔️ Copied</span>
//                 )}
//               </td>

//               <td style={tdStyle}>
//                 <span>
//                   {visibleSecrets[token._id]
//                     ? token.secretId
//                     : '*'.repeat(10)}
//                 </span>
//                 {/* 👁️ Toggle visibility */}
//                 <button
//                   onClick={() => toggleSecret(token._id)}
//                   style={iconButtonStyle}
//                   title="Toggle visibility"
//                 >
//                   {visibleSecrets[token._id] ? <FaEyeSlash color="#fff" /> : <FaEye color="#fff" />}
//                 </button>
//                 {/* 📋 Copy button */}
//                 <CopyToClipboard
//                   text={token.secretId}
//                   onCopy={() => handleCopy(token._id)}
//                 >
                 
//                     <FaRegCopy color="#fff" style={{ cursor: 'pointer', marginLeft: 10 }} />
                  
//                 </CopyToClipboard>
//                 {/* ✔️ Feedback */}
//                 {copiedId === token._id && (
//                   <span style={{ marginLeft: 5, color: 'green' }}>✔️ Copied</span>
//                 )}
//               </td>
//               <td style={tdStyle}>{token.expiryDay}</td>
//               <td style={tdStyle}>
//                 {new Date(token.expiryTs * 1000).toLocaleString()}
//               </td>
//               <td style={tdStyle}>
//                 {new Date(token.created).toLocaleString()}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default TokenTable;







import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaRegCopy, FaEye, FaEyeSlash } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";

const TokenTable = ({ tokens: initialTokens }) => {
  const [tokens, setTokens] = useState(initialTokens);
  const [visibleSecrets, setVisibleSecrets] = useState({});
  const [copiedId, setCopiedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ open: false, tokenId: null });

  const handleDelete = async (tokenId) => {
    try {
      const token = sessionStorage.getItem("ASIToken");
      await axios.get(`/api/v1/integrations/tokens/${tokenId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Token deleted successfully");

      // remove from local state
      setTokens((prevTokens) => prevTokens.filter((t) => t._id !== tokenId));
    } catch (error) {
      console.error("Error deleting token:", error);
      toast.error("Failed to delete token");
    } finally {
      setDeleteModal({ open: false, tokenId: null });
    }
  };

  const toggleSecret = (id) => {
    setVisibleSecrets((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleCopy = (id) => {
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 1500);
  };

  const openDeleteModal = (tokenId) => {
    setDeleteModal({ open: true, tokenId });
  };

  const closeDeleteModal = () => {
    setDeleteModal({ open: false, tokenId: null });
  };

  const columns = [
    {
      name: "Token Name",
      selector: (row) => row.tokenName,
      sortable: true,
      width: "150px",
    },
    {
      name: "User",
      selector: (row) => row.userName,
      sortable: true,
      width: "120px",
    },
    {
      name: "Client ID",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ color: "black" }}>{row.clientId}</span>
          <CopyToClipboard
            text={row.clientId}
            onCopy={() => handleCopy(`client-${row._id}`)}
          >
            <FaRegCopy
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                color: "#6c757d",
              }}
              title="Copy Client ID"
            />
          </CopyToClipboard>
          {copiedId === `client-${row._id}` && (
            <span style={{ marginLeft: "5px", color: "green", fontSize: "0.8em" }}>
              Copied!
            </span>
          )}
        </div>
      ),
      sortable: true,
      width: "220px",
    },
    {
      name: "Secret ID",
      cell: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <span style={{ color: "black" }}>
            {visibleSecrets[row._id] ? row.secretId : "*".repeat(10)}
          </span>
          <button
            onClick={() => toggleSecret(row._id)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              marginLeft: "10px",
              color: "#6c757d",
            }}
            title={visibleSecrets[row._id] ? "Hide Secret" : "Show Secret"}
          >
            {visibleSecrets[row._id] ? <FaEyeSlash /> : <FaEye />}
          </button>
          <CopyToClipboard
            text={row.secretId}
            onCopy={() => handleCopy(`secret-${row._id}`)}
          >
            <FaRegCopy
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                color: "#6c757d",
              }}
              title="Copy Secret ID"
            />
          </CopyToClipboard>
          {copiedId === `secret-${row._id}` && (
            <span style={{ marginLeft: "5px", color: "green", fontSize: "0.8em" }}>
              Copied!
            </span>
          )}
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Expiry Days",
      selector: (row) => row.expiryDay,
      sortable: true,
      width: "120px",
    },
    {
      name: "Expiry Date",
      selector: (row) => new Date(row.expiryTs * 1000).toLocaleString(),
      sortable: true,
      width: "180px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => openDeleteModal(row._id)}
          style={{
            background: "none",
            border: "none",
            color: "#e50202",
            cursor: "pointer",
            padding: "8px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
          title="Delete Token"
        >
          <MdDelete size={20} />
        </button>
      ),
      width: "80px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created).toLocaleString(),
      sortable: true,
      width: "180px",
    },
  ];

  return (
    <div style={{ marginTop: "20px" }}>
      <DataTable columns={columns} data={tokens} />

      {deleteModal.open && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
            }}
          >
            <p>Are you sure you want to delete this token?</p>
            <button
              onClick={() => handleDelete(deleteModal.tokenId)}
              style={{
                marginRight: "10px",
                background: "#e50202",
                color: "white",
                border: "none",
                padding: "8px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Yes
            </button>
            <button
              onClick={closeDeleteModal}
              style={{
                background: "#6c757d",
                color: "white",
                border: "none",
                padding: "8px 12px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              No
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TokenTable;
